import React from "react";
import { Button, ButtonGroup } from "@mui/joy";

interface BooleanToggleProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

const BooleanToggle: React.FC<BooleanToggleProps> = ({ value, onChange }) => {
  const handleToggle = (newValue: boolean) => {
    // If clicking the currently selected button, deselect it (set to null)
    if (value === newValue) {
      onChange(null);
    } else {
      onChange(newValue);
    }
  };

  return (
    <ButtonGroup
      sx={{
        width: "100%",
        height: "52px",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <Button
        onClick={() => handleToggle(true)}
        variant={value === true ? "solid" : "outlined"}
        sx={{
          flex: 1,
          height: "52px",
          fontSize: "16px",
          bgcolor: value === true ? "#2E2D7E" : "#edeff3",
          color: value === true ? "#FFFFFF" : "#1A1B1D",
          border: "none",
          borderRadius: 0,
          "&:hover": {
            bgcolor: value === true ? "#2E2D7E" : "#e0e2e6",
          },
        }}
      >
        Yes
      </Button>
      <Button
        onClick={() => handleToggle(false)}
        variant={value === false ? "solid" : "outlined"}
        sx={{
          flex: 1,
          height: "52px",
          fontSize: "16px",
          bgcolor: value === false ? "#2E2D7E" : "#edeff3",
          color: value === false ? "#FFFFFF" : "#1A1B1D",
          border: "none",
          borderRadius: 0,
          "&:hover": {
            bgcolor: value === false ? "#2E2D7E" : "#e0e2e6",
          },
        }}
      >
        No
      </Button>
    </ButtonGroup>
  );
};

export default BooleanToggle;

